/**
 * Tarjeta de KPI del dashboard (presentacional).
 *
 * Compone la `Card` de la librería de UI (`components/ui`): un rótulo y un valor
 * grande. Sin lógica de negocio ni llamadas a la API (`docs/frontend_
 * architecture.md`, Pr. 6): solo presenta el dato que le pasa la pantalla.
 */
import { Card, CardContent } from "@/components/ui";

export interface KpiCardProps {
  /** Rótulo del indicador (p. ej. "Pendientes"). */
  label: string;
  /** Valor a mostrar; ya formateado por quien lo pasa (número o string). */
  value: string | number;
  /**
   * Clase del icono Font Awesome (p. ej. `"fas fa-clock"`). Si se pasa, se pinta
   * el cuadro azul con el glifo a la izquierda (paridad con las `stats-card` del
   * SSR). Opcional.
   */
  icon?: string;
}

export function KpiCard({ label, value, icon }: KpiCardProps) {
  return (
    <Card>
      <CardContent className="flex items-center gap-3 py-3">
        {icon && (
          <span
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-lg"
            style={{ background: "#DBEAFE", color: "#2563EB" }}
            aria-hidden="true"
          >
            <i className={icon} />
          </span>
        )}
        <span className="flex min-w-0 flex-col gap-0.5">
          <span className="text-2xl font-bold text-slate-900">{value}</span>
          <span className="text-sm font-medium text-slate-500">{label}</span>
        </span>
      </CardContent>
    </Card>
  );
}
